import _extends from "@babel/runtime/helpers/extends";
import { colorUseCases, getColorScaleFromThemeObject, theme } from "@vitality-ds/system";
var text = colorUseCases.text;
export default (function (baseStyles, _ref) {
  var isMulti = _ref.isMulti;
  return _extends({}, baseStyles, {
    color: getColorScaleFromThemeObject("neutral", text.placeholder, theme),
    marginLeft: isMulti && 8
  });
});